<div class="screen-spacer">
	<app-is-in-view class="is-in-view"></app-is-in-view>
</div>
<div class="page-content">
	
	<app-page-header class="page-header" *ngIf="(currentTaxonomyPage$ | push) as page" [page]="page" (click)="setScrollIntoView(pageName)" ></app-page-header>

	<div class="main-content" [ngClass]="class">

		<app-subpage-navigation *ngIf="page.data.subPage" [subPages]="getSubPage(subPages$ | push)"></app-subpage-navigation>
		<app-scroll-into-view class="scroll-into-view subpage" [id]="pageName"></app-scroll-into-view>
		
		<section class="dinamic-offer" *ngIf="(showRecommended$ | push)" [@ifHeightAnimation] >

			<app-data 
				[displayPage]="false"
				[dataSource]="{storeName: '/recommended_ukrajinu', id: '', static: true}"
			>
				<ng-template 
					#optionTemplate 
					let-articles$="articles$"
					let-count$="count$" 
					let-status$="status$"
					let-pageParams$="pageParams$"
					let-displayPage="displayPage"
					let-scrollInToView$="scrollInToView$"
				>
					<app-loader class="loader" [status$]="status$"></app-loader>

					<div class="header">
						<app-icon class="filter-icon" name="filter" [shadow]="false"></app-icon>
						<span>doporučujeme</span>
					</div>
					<app-grid 
						[articles$]="articles$" 
						[displayPage]="displayPage"
						[queryParams$]="queryParams$"
						[orphan]="true"
					></app-grid>
				</ng-template>			
			</app-data>
		</section>

		

		<app-data 
			[displayPage]="false"
			[dataSource]="{storeName: pageName, id: '', static: false}"
		>
			<ng-template 
				#optionTemplate 
				let-articles$="articles$"
				let-count$="count$" 
				let-status$="status$"
				let-pageParams$="pageParams$"
				let-displayPage="displayPage"
				let-scrollInToView$="scrollInToView$"
				let-pager$="pager$"
			>
				<app-loader class="loader" [status$]="status$"></app-loader>
				
				<app-search-bar 
					[count$]="count$"
					[status$]="status$" 
					[articles$]="articles$" 
					[pageParams$]="pageParams$"
					[pageName]="pageName"
					[scrollInToView$]="scrollInToView$"
					[class]="class"						
				></app-search-bar>

				<div class="grid-wrapper" [ngClass]="class"> 

					<app-grid 
						[articles$]="articles$" 
						[displayPage]="displayPage"
						[queryParams$]="queryParams$"
					></app-grid>

					<app-pager 
						[status$]="status$" 
						[pager$]="pager$"
					></app-pager>
				
				</div>
			</ng-template>
		</app-data>

	</div>
</div>

<app-page-bottom></app-page-bottom>

